import { render, staticRenderFns } from "./SDropdown.vue?vue&type=template&id=5630c435&scoped=true&"
import script from "./SDropdown.vue?vue&type=script&lang=js&"
export * from "./SDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SDropdown.vue?vue&type=style&index=0&id=5630c435&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5630c435",
  null
  
)

export default component.exports